import Vue from 'vue'
import App from './App.vue'
import router from './router'
import config from './config'
Vue.config.productionTip = false

/**
 * 路由守卫
 *
 * @author terrfly
 * @site https://www.jeepay.vip
 * @date 2021/5/8 07:18
 */
router.beforeEach((to, from, next) => {
    // 冻结后的嵌入站点路由直接放行
    const personWebRoutes = ['PersonWebHome', 'PersonWebArticles', 'PersonWebArticle', 'PersonWebSourceDownload'];
    if (personWebRoutes.includes(to.name)) {
      next()
      return false
    }

    // 如果在免登录页面则直接放行
    if (config.passGuardRouteList.includes(to.name)) {
      next()
      return false
    }

    //获取token参数
    let token = to.params[config.urlTokenName];
    if(token){
        config.cacheToken = token;
    }

    if(!config.cacheToken) {
        next({ name: config.errorPageRouteName, params: { errInfo: "请通过二维码进入支付页面！" } })
        return false;
    }

    // 不再检查wayCode，因为收银台会从数据库读取支持的支付方式
    next()
})


Vue.prototype.$config = config;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
